<template>
  <div class="column is-half-mobile">
    <div class="box">
      <b-tooltip :label="description" v-if="description">
        <p>
          <span class="has-text-weight-bold">{{ text }}</span>
        </p>
        {{ `${payments.currencySymbol} ${formatMoney(value)}` }}
      </b-tooltip>

      <p v-else>
        <span class="has-text-weight-bold">{{ text }}</span>
        <br />
        {{ `${payments.currencySymbol} ${formatMoney(value)}` }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../mixins/mask";

export default {
  props: ["text", "value", "description"],

  mixins: [mask],

  computed: {
    ...mapGetters(["payments"])
  }
};
</script>
